import { render, staticRenderFns } from "./TarifsSanteTns.vue?vue&type=template&id=1634e8ad&scoped=true&"
import script from "./TarifsSanteTns.vue?vue&type=script&lang=js&"
export * from "./TarifsSanteTns.vue?vue&type=script&lang=js&"
import style0 from "./TarifsSanteTns.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TarifsSanteTns.vue?vue&type=style&index=1&id=1634e8ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634e8ad",
  null
  
)

export default component.exports